import { Locales } from "@/enums/enums";
import { accountModal } from "@/model/type";

class AccountFacade {
  ToAccountList(_accountList: any, language: Locales): Array<accountModal> {
    const accountList = Array<accountModal>();
    if (_accountList !== null) {
      for (let i = 0; i < _accountList.length; i++) {
        const accountData: accountModal = {
          id: _accountList[i].id,
          code: _accountList[i].code,
          name: {
            locale: language === Locales.EN ? _accountList[i].nameEnglish : _accountList[i].nameThai,
            thai: _accountList[i].nameThai,
            english: _accountList[i].nameEnglish,
          },
          accountTypeSubId: _accountList[i].accountTypeSubId,
          taxIncomeTypeId: _accountList[i].taxIncomeTypeId,
          whtValue: _accountList[i].whtValue,
          referenceTypeId: _accountList[i].referenceTypeId,
          subReferenceTypeId: _accountList[i].subReferenceTypeId,
          isMain: _accountList[i].isMain,
          suggestAccountVatType: _accountList[i].accountVatType,
        };
        accountList.push(accountData);
      }
    }
    return accountList;
  }
}

export default new AccountFacade();
